if (!customElements.get('wlsn-product-facet')) {
  class WLSNProductFacet extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;

      this.classes = {
        loading: 'loading',
        results: 'wlsn-product-facet'
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this.addEventListener('wlsn:pagination:page-changed', this._onPaginationChange.bind(this));
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      this.removeEventListener('wlsn:pagination:page-changed', this._onPaginationChange);
    }

    /**
     * Handle pagination change event
     * @param {Event} event - The pagination change event
     * @returns {Promise<void>}
     */
    async _onPaginationChange(event) {
      const url = new URL(event.detail.url);

      this._abort();
      this._setLoading();

      try {
        this.abortController = new AbortController();
        const res = await fetch(url.toString(), { signal: this.abortController.signal });
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newFacet = doc.querySelector(`${this.classes.results}`);

        if (newFacet) {
          this.innerHTML = newFacet.innerHTML;
          history.replaceState({}, '', url);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      } finally {
        this._removeLoading();
      }
    }

    /**
     * Abort current fetch request
     * @returns {void}
     */
    _abort() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    }

    /**
     * Set loading state
     * @returns {void}
     */
    _setLoading() {
      this.classList.add(this.classes.loading);
    }

    /**
     * Remove loading state
     * @returns {void}
     */
    _removeLoading() {
      this.classList.remove(this.classes.loading);
    }
  }

  customElements.define('wlsn-product-facet', WLSNProductFacet);
}
